import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/* Password field with a show/hide eye toggle. Drop-in for any password input —
   pass the usual props (data-testid, value, onChange, className, minLength…). */
export default function PasswordInput({ className = "field", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} className={`${className} !pr-12`} />
      <button
        type="button"
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : undefined}
        onClick={() => setShow(!show)}
        aria-label={show ? "Hide password" : "Show password"}
        tabIndex={-1}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-accent transition-colors"
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
